import { render } from "./StarView.vue?vue&type=template&id=ff393c04"
import script from "./StarView.vue?vue&type=script&lang=js"
export * from "./StarView.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__